export default __webpack_public_path__ + "static/media/pak.12204766.jpg";